enum ProposalTypeEnum {
  Deal = 'A',
  Renegotiation = 'R',
}

export default ProposalTypeEnum
